import { FC } from 'react';
import { useTitle } from 'react-use';

import { buildPageTitle } from '@savgroup-front-common/core/helpers';
import { BaseLoader } from '@savgroup-front-common/core/molecules/BaseLoader';

import { $HomeProductsListWrapper } from '../HomePage.styles';

import { HomePageFileItem } from './HomePageFileItem/HomePageFileItem';
import useListOwnerProductsQuery from './HomePageFiles.hooks';
import messages from './messages';

export const HomePageFiles: FC = () => {
  const { products, isLoading } = useListOwnerProductsQuery();

  useTitle(buildPageTitle([messages.filesTitlePage]));

  if (isLoading) {
    return <BaseLoader />;
  }

  return (
    <$HomeProductsListWrapper>
      {products?.map((product) => (
        <HomePageFileItem product={product} key={product.ownerProductId} />
      ))}
    </$HomeProductsListWrapper>
  );
};
